import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Network } from '@capacitor/network';
import { AlertController } from '@ionic/angular';
@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  isOnline: boolean = true;
  private statusSubject = new BehaviorSubject<boolean>(true);
  noInternetAlert: HTMLIonAlertElement;
  noInternetAlertPresented: boolean;
  networkStatusInterval: any;

  constructor( private alertController: AlertController) { }

   getStatus(): Observable<boolean> {
    this.logNetworkState();
    return this.statusSubject.asObservable();
  }

  startMonitorNetwork() {
    Network.addListener('networkStatusChange', (status) => {
      this.isOnline = status.connected;
    });
    this.setupNetworkPoll();
  }

  logNetworkState() {
    Network.getStatus().then(status => {
      this.isOnline = status.connected;
      this.statusSubject.next(status.connected);
    });
  }

  stopMonitorNetwork() {
    Network.removeAllListeners();
    clearInterval(this.networkStatusInterval);
  }

  async setupNetworkPoll() {
    this.networkStatusInterval = setInterval(() => {
      this.getStatus().subscribe(status => {
        //console.log("Current network status: " + status);
      });
    }, 5000);
  }

  setInternetStatusAlert() {
    if (this.noInternetAlertPresented && this.isOnline) {
      this.noInternetAlertPresented = false;
      this.noInternetAlert.dismiss();
    }
    else if (!this.noInternetAlertPresented && !this.isOnline){
      this.noInternetAlertPresented = true;
      this.presentNoInternetAlert();
    }
  }

  async presentNoInternetAlert() {
    this.noInternetAlert = await this.alertController.create({
      header: 'No internet connection',
      message: 'Please check your internet connection.',
      buttons: ['OK'],
      backdropDismiss: false,
    });
    this.noInternetAlert.onDidDismiss()
      .then(() => {
        this.noInternetAlertPresented = false;
      });
    await this.noInternetAlert.present();
  }
}
